<script setup lang="ts">
const props = defineProps({
  helpModalTtl: { type: String, required: true },
  helpModalTxt: { type: String, required: true },
  helpModalFlg: { type: Boolean, required: true, default: false },
});

const emit = defineEmits(["close-help-modal"]);

const closeHelpModal = (event: any) => emit("close-help-modal", event);
</script>

<template>
  <transition name="helpModal" appear>
    <div
      v-if="helpModalFlg"
      class="helpModal-overlay"
      @click.self="closeHelpModal"
    >
      <div class="helpModal-content">
        <div class="helpModal-fixedTtl">
          <div class="helpModal-header">
            用語説明
            <img
              src="~/assets/images/compare/icon_help_close.png"
              width="40"
              height="40"
              alt=""
              class="helpModal-close"
              @click="closeHelpModal"
            />
          </div>
          <div class="helpModal-termTtl">
            {{ helpModalTtl }}
          </div>
        </div>
        <div class="helpModal-txt" v-html="helpModalTxt"></div>
      </div>
    </div>
  </transition>
</template>

<style lang="scss" scoped>
.helpModal-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.helpModal-content {
  width: 91%;
  max-height: 50%;
  overflow-y: scroll;
  background-color: $colorDefaultBackground;
  border-radius: 8px;
}

.helpModal-fixedTtl {
  position: fixed;
  top: auto;
  width: 91%;
}

.helpModal-header {
  display: flex;
  align-items: flex-start;
  background: #1C79C6;
  padding: 2.33% 3.5% 2.92%;
  font-weight: bold;
  font-size: px(16);
  color: $colorWhite;
  border-radius: 8px 8px 0 0;
}

.helpModal-close {
  width: 4.66%;
  padding: 1.5% 0 0 3.2%;
  margin-left: auto;
}

.helpModal-termTtl {
  background: #EFEFEF;
  padding: 2.33% 3.5% 2.92%;
  font-weight: bold;
  font-size: px(16);
  color: $colorBasicText;
}

.helpModal-txt {
  padding: 27.11% 3.5% 4.2%;

  :deep(p) {
    margin-bottom: 2.1%;
    color: $colorBasicText;
    letter-spacing: 0;
    font-size: px(14);
    font-weight: normal;

    span {
      font-size: px(11);
      vertical-align: top;
    }

    &:last-child {
      margin-bottom: 0;
    }

    &.helpModal-txt-memo {
      margin-bottom: 0;
      font-size: px(13);
      color: #666666;
      text-indent: -1em;
      padding-left: 1em;

      &.widthNumber {
        text-indent: -1.8em;
        padding-left: 1.8em;
      }
    }
  }
}

// transition
.helpModal-enter-active,
.helpModal-leave-active {
  transition: opacity 0.4s;
}
.helpModal-enter-from,
.helpModal-leave-to {
  opacity: 0;
}

@include media(pc) {
  .helpModal-content {
    width: 640px;
    max-height: 100%;
    overflow-y: hidden;
  }

  .helpModal-fixedTtl {
    position: static;
    width: auto;
  }

  .helpModal-header {
    font-size: px(16);
    padding: 10px 24px 12px 16px;
  }

  .helpModal-close {
    width: 12px;
    padding: 7px 0 0 20px;
    margin-left: auto;
    &:hover {
      cursor: pointer;
    }
  }

  .helpModal-termTtl {
    padding: 10px 16px 12px;
  }

  .helpModal-txt {
    padding: 10px 16px 12px;

    :deep(p) {
      margin-bottom: 10px;
    }
  }
}
</style>
